import { __decorate, __metadata } from "tslib";
import ListOperationServLock from '@/presentation/pages/detail/basic/interface_lock/ListOperationServLock';
import { useRemoveViewDataConfirm } from '@/presentation/pages/detail/basic/hooks/useRemoveViewDataConfirm';
import { useUpdateReadStatus } from '@/presentation/pages/detail/basic/hooks/useUpdateReadStatus';
import { useRefreshWithParams } from '@/presentation/pages/detail/basic/hooks/useRefreshWithParams';
import { PageSelectorServiceSymbol } from '@/presentation/components/page-selector/PageSelectorService';
import { CopyMoveViewDataServiceSymbol } from '@/presentation/pages/detail/basic/service/CopyMoveViewDataService';
import { injectable, injectService } from '@/inversify.config';
let MergerOperationService = class MergerOperationService extends ListOperationServLock {
    constructor() {
        super();
        this.pageSelectorService = injectService(PageSelectorServiceSymbol);
        this.copyMoveViewDataService = injectService(CopyMoveViewDataServiceSymbol);
    }
    onUnselectAll() {
        throw new Error('onUnselect is not implemented');
    }
    get selectedCount() {
        return this.pageSelectorService.selectedCount;
    }
    async startTargetFolderSelection(mode) {
        return this.copyMoveViewDataService.open({ mode, selectedCount: this.selectedCount });
    }
    async onCopy() {
        const target = await this.startTargetFolderSelection('copy');
        await this.copyMoveViewDataService.makeChange({
            spaceId: this.spaceId,
            folderId: this.folderId,
            ...target,
        });
    }
    async onMove() {
        const target = await this.startTargetFolderSelection('move');
        await this.copyMoveViewDataService.makeChange({
            spaceId: this.spaceId,
            folderId: this.folderId,
            ...target,
        });
        useRefreshWithParams();
        this.pageSelectorService.unselectAll();
    }
    onDelete() {
        const { state } = useRemoveViewDataConfirm();
        return state.then(success => {
            if (success) {
                this.onUnselectAll();
                useRefreshWithParams();
            }
        });
    }
    onSetReadStatus(type) {
        const { updateReadStatus } = useUpdateReadStatus();
        return updateReadStatus(type).then(data => {
            data && data.async && useRefreshWithParams();
        });
    }
};
MergerOperationService = __decorate([
    injectable(),
    __metadata("design:paramtypes", [])
], MergerOperationService);
export default MergerOperationService;
